import { useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useAuth } from "@/contexts/AuthContext"

export function Login() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const { login, error, clearError } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const resetMessage = (location.state as { resetMessage?: string } | null)
    ?.resetMessage

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    clearError()
    const success = await login({ email, password })
    if (success) {
      navigate("/chat", { replace: true })
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-4 rounded-lg border p-6 shadow-sm"
      >
        <h1 className="text-center text-xl font-semibold">Sign in</h1>
        {resetMessage && (
          <p className="text-center text-sm text-foreground" role="status">
            {resetMessage}
          </p>
        )}
        {error && (
          <p className="text-center text-sm text-destructive" role="alert">
            {error}
          </p>
        )}
        <div className="space-y-2">
          <label htmlFor="login-email" className="text-sm font-medium">
            Email
          </label>
          <Input
            id="login-email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            className="w-full"
          />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <label htmlFor="login-password" className="text-sm font-medium">
              Password
            </label>
            <Link
              to="/forgot-password"
              className="text-sm text-muted-foreground underline"
            >
              Forgot password?
            </Link>
          </div>
          <Input
            id="login-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full"
          />
        </div>
        <p className="text-center text-sm text-muted-foreground">
          <Link to="/register" className="underline">Register</Link> a new account
        </p>
        <Button type="submit" className="w-full">
          Sign in
        </Button>
      </form>
    </div>
  )
}
